(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-einstant/assets/javascripts/shared/components/tickets-row-wrapper.js') >= 0) return;  svs.modules.push('/modules/tickets-einstant/assets/javascripts/shared/components/tickets-row-wrapper.js');
"use strict";


const {
  Fragment
} = React;
const TicketsRowWrapper = _ref => {
  let {
    category
  } = _ref;
  const {
    DesktopPagination,
    CategoryTicketsWheel
  } = svs.eInstant.shared.components;
  return React.createElement(Fragment, null, React.createElement(CategoryTicketsWheel, {
    category: category
  }), React.createElement(DesktopPagination, {
    category: category
  }));
};
setGlobal('svs.eInstant.shared.components.TicketsRowWrapper', TicketsRowWrapper);

 })(window);